import React from 'react'
import Image from '../components/Image'

export default class Author extends React.Component {
  constructor(props) {
    super(props)
    this.state = {

    }
  }
  componentDidMount() {

  }
  render() {
    return (
      <section className={this.props.className}>
        <Image {...this.props.avatar} maxWidth={120} />
        <p>
          <strong className="mr-3">{this.props.name}</strong>
          <span>{this.props.about}</span>
        </p>
      </section>
    )
  }
}



// WEBPACK FOOTER //
// ./src/contents/Author.js